module.exports = __webpack_public_path__ + "img/ar07.92f18ddb.jpg";